module.exports = __webpack_public_path__ + "media/images/icons/icons_small/10_heartbullet-d552ab54dfc1a1dc098e1433fedf4959.png";